<template>
  <div>
    <img
      v-if="ChooseImageShapeActive"
      :src="ChangeImgUrl"
      class="custom-image"
      @click="showFileChooser"
    />
    <div v-else>
      <button  v-bind:class="{ choose_image_shape_active: ChooseImageShapeActive }" type="button" @click="showFileChooser" class="btn btn-upload-shape-image">
        Select image
      </button>
    </div>

    <v-dialog />
    <modal
      :name="modalName"
      :adaptive="true"
      height="auto"
      width="1000"
      @ok="onCrop"
      @cancel="handleCancel"
      :clickToClose="true"
      :reset="true"
      class='Modal_crop_box'
    >
      <div @click="hideModal" class="Abn-modal-close">&#10005;</div>
      <div class='Abn-modal-crop'>
      <div class="modal-wrapper">
        <div v-if="!OnCrop" class="cropper-wrapper Abn-box-image-shape">

          <div class="Abn-box-image-shape-cropper">
              <vue-cropper
                v-if="imgData"
                ref="cropper"
                :aspect-ratio="aspectRatio"
                :src="imgData"
                :zoom="zoom"
                preview=".preview"
                @ready="ChangeCrop"
              />
          </div>

          <!-- <div class="Abn-box-image-shape-cropper-preview">
             <section class="preview-area">
              <div class="preview" />
              <div class="image-preview-box-crop">
                <img :width="WidthBox" :height="HeightBox" class="image-preview-box-crop-url" :src="UrlImageShapePreview">
              </div>
            </section>
          </div> -->

        </div>

        <div v-if="OnCrop" class="Abn-Image-shape">
          <div class="">
             <img class="Abn-Image-shape-image-crop" :src="UrlImageUpload">
          </div>

          <div>
            <img class="Abn-Image-shape-url" :src="UrlImageShape">
          </div>
        </div>

      </div>
      </div>

       <div class="Abn-modal-footer">
          <div class="Abn-modal-footer-div">
            <!-- <button type="button" v-if='this.OnCrop' @click="ButtonOnPrev" class="btn Abn-btn-cancel">Prev</button> -->
            <button type="button" @click="hideModal" class="btn Abn-btn-cancel">Cancel</button>
            <button type="button" class="btn Abn-btn-apply" @click="ButtonApply">Apply</button>
            <!-- <button type="button" v-if='!this.OnCrop' @click="onCrop" class="btn Abn-btn-apply">Next</button> -->
          </div>
        </div>


    </modal>
    <input
      ref="input"
      type="file"
      name="image"
      accept="image/*"
      @change="setImage"
    />
  </div>
</template>
<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import axios from 'axios'
import { ASSET_URL, URL_API_IMAGE_SHAPE, URL_API_FILL_IMAGES_SHAPE } from '@/config.js'
import Image from '../Artwork/Image.vue'
import jQuery from 'jquery'
import { mapGetters, mapMutations } from 'vuex'
import {get} from 'lodash'
export default {
  props: {
    context: {
      type: Object,
      required: true
    },
    aspectRatio: {
      type: Number,
      default() {
        return 1
      }
    },
    shapes: {
      type: String,
      default() {
        return null
      }
    },
    name: {
      type: String,
      default(){
        return null
      }
    }
  },
  components: {
    VueCropper
  },
  data() {
    return {
      file: null,
      imgData: null,
      cropData: null,
      showCropper: false,
      loading: false,
      messageLoading: false,
      UrlImageUpload: null,
      OnCrop: false,
      UrlImageShape: null,
      UrlImageShapePreview: null,
      HeightBox: null,
      WidthBox: null,
      ChooseImageShapeActive: false,
      ChangeImgUrl: null,
      imgObjectUrl: null,
      maxImageDimension: 2500
    }
  },
  watch: {
    context(value){
      const key = get(value, 'model.key', null);
      if(key && this.isSaveLocalstorage() && (key.indexOf('upload-custom') >= 0 || key.indexOf('image_shape') >= 0)){
        this.ChangeImgUrl = ASSET_URL + '/' + key;
        this.ChooseImageShapeActive = true;
      }
    },
    file(file) {
      if (file) {
        if (file.type.indexOf('image/') === -1) {
          alert('Please select an image file')
          return
        }
        this.$modal.show(this.modalName, {}, { title: 'ok' })

        this.resizeImage(file, this.maxImageDimension)
          .then(objectUrl => {
            if (this.imgObjectUrl) {
              URL.revokeObjectURL(this.imgObjectUrl)
            }
            this.imgObjectUrl = objectUrl
            this.imgData = objectUrl
            this.showCropper = true
            this.setLoadingForm(false)
            if (this.$refs.cropper) {
              this.$refs.cropper.replace(objectUrl)
            }
          })
          .catch(err => {
            console.error(err)
            this.setLoadingForm(false)
            alert('Unable to load this image, please try a different one')
          })
      }
    }
  },
  computed: {
    modalName() {
      return `cropper-${this.uniqueID(10)}`
    },
    localStorageName(){
      return this.context.name + '_' + this.product().id;
    }
  },
  created(){
    this.UrlImageShape = ASSET_URL + '/' + this.shapes
  },
  beforeDestroy() {
    if (this.imgObjectUrl) {
      URL.revokeObjectURL(this.imgObjectUrl)
    }
  },
  methods: {
    ...mapGetters([
      'product',
      'platform',
      'getCartData',
      'isSaveLocalstorage'
    ]),
    ...mapMutations([
      'setCartDataByKey',
      'setMessageError',
      'setLoadingForm',
      'setIsSaveLocalstorage'
    ]),
    setImage(e) {
      this.OnCrop = false
      this.setLoadingForm(true)
      this.file = e.target.files[0]
      e.target.value = null
    },
    showFileChooser() {
      this.$refs.input.click()
    },
    ButtonOnPrev(e){
      e.preventDefault()
      this.OnCrop = false
    },
    async ButtonApply(e){
      e.preventDefault()

      this.setLoadingForm(true);
      const OnThis = this;
      const reader = new FileReader();
      reader.addEventListener("load", async () => {
        const up = await this.upload(reader.result)
        if(up.status){
          OnThis.setCartDataByKey({
            key: OnThis.localStorageName,
            name: OnThis.context.label,
            value: ASSET_URL + '/' + up.key
          });
        }
      }, false);
      reader.readAsDataURL(this.file);

      this.UrlImageUpload = this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg')

      const UploadImg = await this.upload(this.UrlImageUpload)
      if(UploadImg.status){
        try{
          const ImageShapeRawResponse = await fetch(URL_API_IMAGE_SHAPE, {
            method: 'post',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              urlShape : this.UrlImageShape,
              urlImages: ASSET_URL + '/' + UploadImg.key
            })
          });
          const contentCanvas = await ImageShapeRawResponse.json();
          const file = {
            id: this.context.name,
            key: contentCanvas.key
          }
          this.ChangeImgUrl = ASSET_URL + '/' + contentCanvas.key
          this.setIsSaveLocalstorage(true);
          this.context.model = file
          this.$modal.hide(this.modalName)
          this.ChooseImageShapeActive = true
        }catch(err){
          this.setLoadingForm(false)
          this.setMessageError(true);
        }
      }
      this.setLoadingForm(false)
    },
    hideModal(e) {
      e.preventDefault()
      this.$modal.hide(this.modalName)
    },
    async onCrop() {
      this.setLoadingForm(true)

      this.UrlImageUpload = this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg')

      this.OnCrop = true

      this.setLoadingForm(false)
    },
    handleCancel() {
      if (!(this.value && this.value.base64)) {
        this.file = null
      }
      this.showCropper = false
    },
    uniqueID(length) {
      var result = ''
      var chars =
        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)]
      return result
    },
    zoom(e) {
      if (e.detail.ratio > 1) {
        e.preventDefault()
      }
    },
    resizeImage(file, maxDimension) {
      return new Promise((resolve, reject) => {
        const sourceUrl = URL.createObjectURL(file)
        const img = new window.Image()
        img.onload = () => {
          const width = img.naturalWidth
          const height = img.naturalHeight
          const scale = Math.min(1, maxDimension / Math.max(width, height))
          const canvas = document.createElement('canvas')
          canvas.width = Math.max(1, Math.round(width * scale))
          canvas.height = Math.max(1, Math.round(height * scale))
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
          URL.revokeObjectURL(sourceUrl)
          const mime = file.type === 'image/png' ? 'image/png' : 'image/jpeg'
          canvas.toBlob(
            blob => {
              if (!blob) {
                reject(new Error('Canvas toBlob failed'))
                return
              }
              resolve(URL.createObjectURL(blob))
            },
            mime,
            0.92
          )
        }
        img.onerror = () => {
          URL.revokeObjectURL(sourceUrl)
          reject(new Error('Failed to load image'))
        }
        img.src = sourceUrl
      })
    },
    ChangeCrop(e){
      // console.log(e)

      const AbnDomCrop = document.querySelector('.cropper-crop-box')

      AbnDomCrop.style.Position = 'relative';

      var Abndiv = document.createElement("div");
      Abndiv.className = "hdev-shape-image-dom"

      Abndiv.style.Position = 'absolute'

      var Abnimg = document.createElement('img')
      Abnimg.src = this.UrlImageShape

      Abndiv.append(Abnimg)

      AbnDomCrop.append(Abndiv)

      const DomCanvas = jQuery('.preview')

      var Width = 1000
      var Height = 1000

      if(DomCanvas.length){
        Width =  DomCanvas[0].offsetWidth
        Height = DomCanvas[0].offsetHeight
      }

      this.HeightBox = Height;
      this.WidthBox = Width;
    },
    async upload(base64) {
      var file = await fetch(base64)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], 'tmp.png', { type: 'image/png' }))
      var signedUrl = await this.getSignedUrl(file.type)
      const pull = await axios
        .put(signedUrl.url, file, {
          headers: {
            'Content-Type': file.type
          }
        })
        .catch(err => console.error(err))
      if(pull.status === 200){
        return {
          status: true,
          key: signedUrl.key
        }
      }else {
        return {
          status: false
        }
      }
    },
    async getSignedUrl(mime) {
      var headers = new Headers()
      headers.append('Content-Type', 'application/json')
      var requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
      }
      var signedUrl = null
      await fetch(
        `${this.$options.AWS_API}/signedUrl?type=${mime}`,
        requestOptions
      )
        .then(response => response.json())
        .then(res => (signedUrl = res))
        .catch(err => console.error(err))
      return signedUrl
    }
  }
}
</script>


<style>
.Modal_crop_box > div  {
  overflow: auto !important;
}
@media only screen and (max-width: 739px){
  .Modal_crop_box .vm--modal{
    top: 0px !important;
    height: 100vh !important;
    bottom: 0 !important;
    background: white !important;
    padding: 10px;
  }
}


.Modal_crop_box > div::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

.Modal_crop_box > div::-webkit-scrollbar-thumb {
  background-color: #341a1a;
}


@media only screen and (max-width: 739px){
	.Abn-modal-close {
    z-index: 9999999;
    display: none !important
}

.Abn-modal-footer-div {
    display: flex;
}

.Abn-modal-footer-div > button {
    border-radius: 5px;
}
.Abn-modal-crop {
    margin-top: 20px !important;
}
}

.hdev-shape-image-dom {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
}

.hdev-shape-image-dom img{
  opacity: 0.5;
}

</style>

<style scoped>
input[type='file'] {
  display: none;
}

.message-text-loading {
  color: #e1e1e1;
  font-weight: 500;
  text-shadow: 0px 0px 5px #0000007d;
}

img.custom-image {
  width: 100px;
  height: 80px;
  object-fit: contain;
  box-shadow: rgb(0 0 0 / 20%) 0px 0px 2px 1px;
  border-radius: 3px;
  border: 3px solid var(--primary-color, #5c6ac4);
  cursor: pointer;
}
.copper-wrapper {
  display: grid;
  grid-template-columns: auto 120px;
}
.modal-wrapper {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  /* grid-template-rows: auto 40px; */
}
.modal-wrapper .cropper-wrapper {
  overflow: hidden;
  margin-bottom: 10px;
}

.Abn-modal-crop{
  overflow: auto ;
  width: 600px;
  max-width: 100%;
  margin: 0 auto;
  margin-top: 2px;
  padding: 5px;
}


.Abn-modal-close {
  background: #6e6e6f;
  width: 50px;
  height: 50px;
  text-align: center;
  color: white;
  font-weight: 900;
  position: absolute;
  right: 0;
  font-size: 18px;
  display: flex;
  top: 0px;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  z-index: 9999999999999999999999;
}

.modal-wrapper .cropper-wrapper::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

.modal-wrapper .cropper-wrapper::-webkit-scrollbar-thumb {
  background-color: #341a1a;
}

.Modal_crop_box.vm--container > div > div{
  overflow: auto !important;
}


.Abn-modal-footer{
  display: flex;
  justify-content: space-between;
}

button.btn.Abn-btn-cancel {
  background: #7b7b7e !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
}

button.btn.Abn-btn-apply {
  background: none 0% 0% / auto repeat scroll padding-box border-box rgb(33 171 43) !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
}

.Abn-modal-footer {
    position: sticky;
    bottom: 0px;
    left: 0;
    right: 0;
    background: #ffffff;
}

.Abn-modal-footer-div{
  width: 600px;
  max-width: 100%;
  margin: auto;
  background: #ffffff;
  padding: 10px 0;
}

.Abn-modal-footer-div > button{
  margin: 0 2px;
}

.message-loading-group {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: #5b5b5b87 !important;
  z-index: 9999999999999999 !important;
}

.message-loading-div {
  margin: 0 auto !important;
  width: 100% !important;
  text-align: center !important;
  position: absolute !important;
  top: 50% !important;
}


.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}


.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.Abn-Image-shape{
   position: relative;
  margin-top: 7px ;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  background: darkcyan;
}

.Abn-Image-shape:after {
  content: "";
  display: block;
}

.Abn-Image-shape-image-crop{
  width: 100%;
}

.Abn-Image-shape-url{
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: 0.7;
  position: absolute;
  top: 0;
  bottom: 0;
}


.preview {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}

@media only screen and (max-width: 739px){
	.Abn-modal-footer {
    position: fixed !important;
    bottom: 0;
    left: 0;
    right: 0;
}
}

.Abn-box-image-shape-cropper{
  float: left;
  width: 100%;
}

.Abn-box-image-shape-cropper-preview{
  float: right;
  width: 40%;
}

section.preview-area {
    display: flex;
    position: relative;
}

.image-preview-box-crop-url{
  position: absolute;
    z-index: 999;
    right: 0;
    left: 0;
    opacity: 0.8;
}


.v-ion-abn{
  width: 16px;
  padding: 0;
  margin: 0;
}


.choose_image_shape_active {
    background: #26bf31 !important;
    border: 1px solid #26bf31 !important;
    animation-name: animation_button_active;
  animation-duration: 2s;
}

.hdev-shape-image-dom {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}


@keyframes choose_image_shape_active {
  from {opacity: 0.1;}
  to {opacity: 1;}
}


.v-ion-abn{
  width: 30px;
  padding: 0;
  margin: 0;
}

button.btn.btn-upload-new {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  border: 1px solid #bdbbbb;
  line-height: 1;
  font-size: 14px;
  height: 80px;
}

.group-button-image {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.group-button-image > * {
  margin: 0 5px;
}


</style>



// WEBPACK FOOTER //
// src/components/Formulate/ImageShape.vue